import { sessionAwareFetch } from "../features/auth/sessionAwareFetch";
import { ACTIVE_LOCALE_CHANGE_EVENT, activeLocaleFromDocument } from "./localeRegistry";
import { subscribeSharedTheme } from "../ui/theme";

/** Presentation only; the server independently verifies device ownership and enabled languages. */
export function syncCollectorPresentation(): () => void {
  let stopped = false;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const send = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (stopped) return;
      const locale = activeLocaleFromDocument();
      const theme = document.documentElement.dataset.kavooshTheme;
      if (!locale || (theme !== "light" && theme !== "dark")) return;
      const csrf = document.cookie.split(";").map((part) => part.trim()).find((part) => part.startsWith("kavoosh_csrf="))?.slice("kavoosh_csrf=".length);
      if (!csrf) return;
      const base = import.meta.env.VITE_API_BASE ?? "/api/v1";
      void sessionAwareFetch(`${base}/account/collector-presentation`, {
        method: "POST", credentials: "include", cache: "no-store",
        headers: { "Content-Type": "application/json", ...(csrf ? { "X-CSRF-Token": decodeURIComponent(csrf) } : {}) },
        body: JSON.stringify({ contract_version: "collector-presentation.v1", locale, theme }),
      }).catch(() => { /* Collection authority never depends on a presentation preference. */ });
    }, 100);
  };
  send();
  const unsubscribeTheme = subscribeSharedTheme(send);
  window.addEventListener(ACTIVE_LOCALE_CHANGE_EVENT, send);
  const media = window.matchMedia?.("(prefers-color-scheme: dark)");
  media?.addEventListener?.("change", send);
  return () => {
    stopped = true;
    clearTimeout(timer);
    unsubscribeTheme();
    window.removeEventListener(ACTIVE_LOCALE_CHANGE_EVENT, send);
    media?.removeEventListener?.("change", send);
  };
}
